import { useEffect, useState } from "react";
import { LightBoxForm } from "./LightBoxForm";
import { LightBoxSuccessState } from "./LightBoxSuccessState";

interface Props {
  desktopImage: string;
  mobileImage: string;
}

function LightBox({ desktopImage, mobileImage }: Props) {
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    const lightBoxModal = document.querySelector<HTMLElement>("#lightBox-modal");
    if (!lightBoxModal) return;

    const blockedPaths = ["/login-user", "/checkout"];
    if (blockedPaths.some((path) => globalThis.location.pathname.startsWith(path))) {
      lightBoxModal.style.display = "none";
      return;
    }

    if (localStorage.getItem("LightBox") === "true") {
      lightBoxModal.style.display = "none";
      return;
    }

    const timer = setTimeout(() => {
      lightBoxModal.style.display = "flex";
    }, 15000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    localStorage.setItem("LightBox", "true");
    const modal = document.querySelector<HTMLElement>("#lightBox-modal");
    if (modal) modal.style.display = "none";
  };

  return (
    <div
      id="lightBox-modal"
      className="fixed top-0 right-0 left-0 bottom-0 hidden items-center w-full justify-center bg-[rgba(0,0,0,0.7)] z-[99]"
    >
      <div
        id="lightBox-content"
        className="bg-[#E6E6E6] flex align-center relative"
      >
        <button type="button" onClick={handleClose} className="absolute top-[23px] right-[23px] p-1 cursor-pointer">
          <img src="https://decoims.com/danielatombini/003f3fe4-8b3a-4f73-bf5e-311aabed2c15/light-box-close-icon-2.png" alt="Close" width={20} height={20} />
        </button>
        <img src={mobileImage} alt="Light Box Image" className="hidden" />
        <img src={desktopImage} alt="Light Box Image" className="hidden lg:block" height={550} width={430} />
        {showSuccess
          ? <LightBoxSuccessState onClose={handleClose} />
          : <LightBoxForm onSuccess={() => setShowSuccess(true)} />}
      </div>
    </div>
  );
}

export default LightBox;
